<ng-container #feesDetails [formGroup]="feesDetailsForm">
  <div #tabOneControls class="form-container">
    <h4 class="section-title">{{'FRONT_USER.AGENT_TABS.AGENT_INFO' | translate}}</h4>

    <div class="form-group">
      <label for="name">{{'FRONT_USER.FEES_ESTIMATION_FORM.AGENT_NAME' | translate}}</label>
      <input type="text" formControlName="name" class="form-control" />
    </div>

    <div class="form-group">
      <label for="Phone1">{{'FRONT_USER.AGENT_REGISTRATION_FORM.PHONE1' | translate}}</label>
      <input type="text" formControlName="Phone1" class="form-control" />
    </div>
    <div class="form-group">
      <label for="SelectedCurrency">{{'FRONT_USER.FEES_ESTIMATION_FORM.PAYMENT_CURRENCY' | translate}}</label>
      <input type="text" formControlName="SelectedCurrency" class="form-control" />
    </div>

    <h4 class="section-title">{{'FRONT_USER.FEES_ESTIMATION_TABS.VESSEL_PARTICULARS' | translate}}</h4>
    <div class="form-group">
      <label for="VesselName">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.VESSEL_NAME' | translate}}</label>
      <input type="text" name="VesselName" id="VesselName" class="form-control" formControlName="VesselName" />
    </div>

    <div class="form-group">
      <label for="SCID">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SCID' | translate}}</label>
      <input type="text" name="SCID" id="SCID" class="form-control" formControlName="SCID" />
    </div>

    <div class="form-group">
      <label for="CallSign">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.CALL_SIGN' | translate}}</label>
      <input type="text" name="CallSign" id="CallSign" class="form-control" formControlName="CallSign" />

    </div>

    <div class="form-group">
      <label for="ShipTypeId">{{'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_TYPE'| translate}}</label>
      <select formControlName="ShipTypeId" class="form-control">
        <option [value]='null' selected>
          {{'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_TYPE_CHOOSE' | translate}}
        </option>
        <ng-container *ngFor="let ship of shipTypes">
          <option *ngIf="displayedLang==Languages.English" [value]="ship.Id">
            {{ship.NameEN}}
          </option>
          <option *ngIf="displayedLang==Languages.Arabic" [value]="ship.Id">
            {{ship.NameAR}}
          </option>
        </ng-container>

      </select>

    </div>

    <div *ngIf="showVesselOther" class="form-group">
      <label for="VesselTypeOther">{{'FRONT_USER.FEES_ESTIMATION_FORM.VESSEL_OTHER'| translate}}</label>
      <input type="text" name="VesselTypeOther" id="VesselTypeOther" class="form-control"
        formControlName="VesselTypeOther" />
     
    </div>

    <div class="form-group">
      <label for="dDirectionId">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DIRECTION' | translate}}</label>
      <select formControlName="DirectionId" class="form-control" id="dDirectionId" name="Direction">
        <option [value]="''" selected>
          {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_DIRECTION' | translate}}</option>
        <!-- <option *ngFor="let sailDirection of directions" [value]="sailDirection?.Id">
          {{sailDirection?.Direction}}
        </option> -->
        <ng-container *ngFor="let sailDirection of directions">
            <option *ngIf="displayedLang==Languages.English" [value]="sailDirection?.Id">
              {{sailDirection?.Direction}}
            </option>
            <option *ngIf="displayedLang==Languages.Arabic" [value]="sailDirection?.Id">
              {{sailDirection?.DirectionAR}}
            </option>
          </ng-container>
      </select>

    </div>

    <div class="form-group">
      <label for="ShipNationalityId">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_NATIONALITY' | translate}}</label>
      <select formControlName="ShipNationalityId" class="form-control">
        <option [value]='null' selected>
          {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_NATIONALITY' | translate}}
        </option>
        <ng-container *ngFor="let nationality of nationalities">
          <option *ngIf="displayedLang==Languages.English" [value]="nationality.Id">
            {{nationality.NameEN}}
          </option>
          <option *ngIf="displayedLang==Languages.Arabic" [value]="nationality.Id">
            {{nationality.NameAR}}
          </option>
        </ng-container>

      </select>

    </div>

    <div class="form-group">
      <label for="ShipmentTypeId">{{'FRONT_USER.FEES_ESTIMATION_FORM.SHIPMENT_TYPE'| translate}}</label>

      <select formControlName="ShipmentTypeId" class="form-control">
        <option [value]='null' selected>
          {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_SHIMPMENT_TYPE' | translate}}
        </option>
        <ng-container *ngFor="let shimpment of shipmentTypes">
          <option *ngIf="displayedLang==Languages.English" [value]="shimpment.Id">
            {{shimpment.NameEN}}
          </option>
          <option *ngIf="displayedLang==Languages.Arabic" [value]="shimpment.Id">
            {{shimpment.NameAR}}
          </option>
        </ng-container>
      </select>
    </div>

    <div *ngIf="showShipmentOther" class="form-group">
      <label for="ShipmentOther">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIPMENT_OTHER' | translate}}</label>
      <input type="text" name="ShipmentOther" id="ShipmentOther" class="form-control" formControlName="ShipmentOther" />
    </div>

    <div class="form-group">
      <label for="IsGasShip">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_GAS_TYPE' | translate }}</label>
      <div class="form-custom-inputs">
        <div *ngFor="let gasShip of shipGasTypeKeys;let i='index'" class=" custom-Radio">
          <input type="radio"  name="IsGasShip" [id]=[gasShip] [value]="shipGasType[gasShip]"
            formControlName="IsGasShip" />
          <label [for]="[gasShip]">{{  'FRONT_USER.FEES_ESTIMATION_FORM.'+ gasShip | translate}}</label>
        </div>
      </div>

    </div>

    <div *ngIf="ShowGas" class="form-group">
      <label for="GasType">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.VAPOR_TYPE' | translate}}</label>
      <input type="text" name="GasType" id="GasType" class="form-control" formControlName="GasType" />
    </div>

    <div *ngIf="ShowGas" class="form-group">
      <label for="GazAmount">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.VAPOR_QUANTITY' | translate}}</label>
      <input type="text" name="GazAmount" id="GazAmount" class="form-control" formControlName="GazAmount" />

    </div>

    <div class="form-group">
      <label for="TotalSuezCanalAmout">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SUEZ_CANAL_TONNAGE' | translate}}</label>
      <input type="text" name="TotalSuezCanalAmout" id="TotalSuezCanalAmout" class="form-control"
        formControlName="TotalSuezCanalAmout" />

    </div>



    <div class="form-group">
      <label for="SuezCanalNetTonnage">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SUEZ_CANAL_NET' | translate}}</label>
      <input type="text" name="SuezCanalNetTonnage" id="SuezCanalNetTonnage" class="form-control"
        formControlName="SuezCanalNetTonnage" />

    </div>


    <div class="form-group">
      <label for="Height">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.LENGTH' | translate}}</label>
      <input type="text" name="Height" id="Height" class="form-control" formControlName="Height" />

    </div>



    <div class="form-group">
      <label for="Width">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.BEAM' | translate}}</label>
      <input type="text" name="Width" id="Width" class="form-control" formControlName="Width" />

    </div>

    <div class="form-group">
      <label for="Flake">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.MOORING_BOATS' | translate}}</label>
      <input type="text" name="Flake" id="Flake" class="form-control" formControlName="Flake" />

    </div>

    <div class="form-group">
      <label for="TransitDate">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.TRANSIT_DATE' | translate}}</label>
      <span class="red"> *</span>
      <input class="form-control" #datepickerYMD="bsDatepicker" [bsValue]="bsValue" bsDatepicker
        formControlName="TransitDate" (ngModelChange)="compareTwoDates()"
        [ngClass]="{ 'is-invalid': isTabOneSubmitted ||(f.TransitDate?.dirty  && f.TransitDate?.errors) }">

      <div *ngIf="isTabOneSubmitted ||(f.TransitDate?.dirty && f.TransitDate?.errors)" class="red ">
        <div *ngIf="f.TransitDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
        <div *ngIf="f.TransitDate?.errors?.inValidDateError">
          {{'FRONT_USER.DATE_ERROR' | translate}}
        </div>
      </div>
      <div *ngIf="errorTransitDate.isError" class="red">
        {{ errorTransitDate.errorMessage +' '+ formatedExpirationDate }}
      </div>
      <!-- <div *ngIf="error.isError" class="red">
          {{ error.errorMessage }}
        </div> -->
    </div>
    <!-- [(bsValue)]="DefaultDate" -->
    <div class="form-group">
      <label for="ETA">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.ETA' | translate}}</label>
      <span class="red"> *</span>
      <div class="split-form-group ">
        <input class="form-control" #datepickerYMD="bsDatepicker" [bsValue]="bsValue" bsDatepicker formControlName="ETA"
          (ngModelChange)="compareTwoDates()"
          [ngClass]="{ 'is-invalid': isTabOneSubmitted ||(f.ETA?.dirty  && f.ETA?.errors) }">
        <timepicker id="ETATime" formControlName="ETATime" [hourStep]="1" [minuteStep]="1"></timepicker>
      </div>

      <div *ngIf="isTabOneSubmitted ||(f.ETA?.dirty && f.ETA?.errors)" class="red ">
        <div *ngIf="f.ETA?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
        <div *ngIf="f.ETA?.errors?.inValidDateError">
          {{'FRONT_USER.DATE_ERROR' | translate}}
        </div>
      </div>
      <div *ngIf="isTabOneSubmitted ||(f.ETATime?.dirty && f.ETATime?.errors)" class="red ">
        <div *ngIf="f.ETATime?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
      </div>
      <div *ngIf="error.isError" class="red">
        {{ error.errorMessage }}
      </div>
    </div>


    <div class="form-group">
      <label for="LastTransitDate">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.LAST_TRANSIT_DATE' | translate}}</label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="LastTransitDate"
        [minDate]="null">

    </div>

    <div class="form-group">
      <label for="GraveMaterial">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DANGERIOUS_LIST' | translate}}</label>

      <textarea formControlName="GraveMaterial" class="form-control"></textarea>

    </div>

    <div class="form-group">
      <label for="ComingFrom">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.LAST_PORT' | translate}}</label>
      <input type="text" name="ComingFrom" id="ComingFrom" class="form-control" formControlName="ComingFrom" />

    </div>

    <div class="form-group">
      <label for="DestinedTo">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.NEXT_PORT' | translate}}</label>
      <input type="text" name="DestinedTo" id="DestinedTo" class="form-control" formControlName="DestinedTo" />

    </div>


    <div class="form-group">
      <label for="Scouts">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.PROJECTOR' | translate}}</label>
      <input type="text" name="Scouts" id="Scouts" class="form-control" formControlName="Scouts" />

    </div>

    <div class="form-group">
      <label for="SubmersibleAccess">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.ARRIVAL_DRAFT' | translate}}</label>
      <input type="text" name="SubmersibleAccess" id="SubmersibleAccess" class="form-control"
        formControlName="SubmersibleAccess" />

    </div>

  </div>
  <p class="btns-holder text-right">
    <button type="button" class="btn SCAcustomBtn" (click)="selectTab(1) ">{{ 'FRONT_USER.NEXT' | translate}}</button>
  </p>

</ng-container>